import { fetchingStatuses } from '../reducers/loading';
function read(user, key, typeCheck) {
    if (!user)
        return undefined;
    var raw = 'get' in user ? user.get(key) : user[key];
    return typeCheck(raw) ? raw : undefined;
}
var isNumber = function (value) { return typeof value === 'number'; };
var isString = function (value) { return typeof value === 'string'; };
/**
 * Builds a `Session` object (the contract from `@homeexchange/shared`) out of
 * the legacy Redux state. Wrappers that mount migrated `@homeexchange/*` modules
 * pass the result into `config.session` (or the `session` prop) so libs read
 * `session.status` instead of hand-rolling auth checks.
 *
 * `accessToken` and `userId` are hydrated from `window.gtg` (rendered by Zend
 * from `identity()`) at store init, so the auth signal is available
 * synchronously. Pages that mount `UserContext` later enrich `state.user` with
 * the full user model; we fall back to `state.auth.userId` when that hasn't
 * happened yet (e.g. the collection landing page module).
 */
export function selectSession(state) {
    var _a, _b, _c, _d;
    var hasAccessToken = Boolean((_a = state.auth) === null || _a === void 0 ? void 0 : _a.accessToken);
    var id = (_b = read(state.user, 'id', isNumber)) !== null && _b !== void 0 ? _b : (_c = state.auth) === null || _c === void 0 ? void 0 : _c.userId;
    var userFetchPending = ((_d = state.loading) === null || _d === void 0 ? void 0 : _d.userFetchingStatus) !== fetchingStatuses.FINISHED;
    if (hasAccessToken && id) {
        return {
            status: 'authenticated',
            user: {
                id: id,
                firstName: read(state.user, 'first_name', isString) || undefined,
                lastName: read(state.user, 'last_name', isString) || undefined
            }
        };
    }
    if (hasAccessToken && userFetchPending) {
        return { status: 'loading' };
    }
    return { status: 'anonymous' };
}
